// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"59a74175","686":"d36d82f6","858":"38d55623"}[chunkId] + ".chunk.js";
};